import { configureStore as reduxConfigureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import { persistRootReducer } from './root-reducer';
import { rootSaga } from './root-saga';
import { addModel } from '@app/modules/model/slice';

/* -----------[ configure store ]------------ */
function configureStore() {
  const sagaMiddleware = createSagaMiddleware();

  const middleware = (getDefaultMiddleware: any) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [addModel.type],
      },
    }).concat(sagaMiddleware); 

  const store = reduxConfigureStore({
    reducer: persistRootReducer,
    middleware,
    devTools: false,
  });

  const persistor = persistStore(store);

  rootSaga.forEach(saga => sagaMiddleware.run(saga));

  return { store, persistor };
}

export { configureStore };